import http from "@/http/aisea/axios";
const resource = "/enterprises/owners/crews";

export default {
    recordBooks(enterpriseCrewId, payload) {
        return http.get(`${resource}/${enterpriseCrewId}/timesheets/record_books`, {
            ...payload,
        });
    },
    export(enterpriseCrewId, payload) {
        return http.get(`${resource}/${enterpriseCrewId}/timesheets/record_books/export`, {
            ...payload,
            responseType: "blob",
        });
    },
};